<template>
  <div>
    <div class="agree-step">
      <div class="agree-step-item">
        <div :class="['step-num', stepNum > 0 ? 'ac' : '']">1</div>
        <span>已生成</span>
      </div>
      <div class="line"></div>
      <div class="agree-step-item">
        <div :class="['step-num', stepNum > 0 ? 'ac' : '']">2</div>
        <span>待审核</span>
      </div>
      <div class="line"></div>
      <div class="agree-step-item">
        <div :class="['step-num', stepNum > 2 ? 'ac' : '']">3</div>
        <span>待付款</span>
      </div>
      <div class="line"></div>
      <div class="agree-step-item">
        <div :class="['step-num', stepNum > 3 ? 'ac' : '']">4</div>
        <span>已付款</span>
      </div>
    </div>
    <RefundInfo v-if="applyType > 1" @loadSuccess="formeSuccess"></RefundInfo>
    <ProtocolInfo v-else :protocolId="protocolId" @load="formeSuccess"></ProtocolInfo>
  </div>
</template>

<script>
import ChapterHead from "@/components/business/ChapterHead";
import FileUpload from "@/components/business/FileUpload";
import ProtocolInfo from "@/pages/protocol/view/ProtocolInfo";
import RefundInfo from "@/pages/protocol/refund/RefundInfo";


export default {
  components: {
    ChapterHead,
    FileUpload,
    ProtocolInfo,
    RefundInfo
  },
  props:{
    protocolId: String,
  },
  created () {
    if (this.$route.params.applyType) (this.applyType = this.$route.params.applyType);
  },
  data() {
    return {
      stepNum: 1,
      applyType: 1
    };
  },
  methods: {
    formeSuccess (data) {
      this.stepNum = data.progressCode;
    },
    back () {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
@import 'src/common/form.scss';
//协议报进度
.agree-step {
  display: flex;
  justify-content: center;
  margin-top: 1.042vw;
  .line {
    width: 9.271vw;
    height: 0vw;
    border-bottom: #bfbfbf 0.104vw dashed;
    margin: 1.042vw;
  }
  .agree-step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .step-num {
      width: 2.083vw;
      height: 2.083vw;
      text-align: center;
      line-height: 2.083vw;
      border-radius: 50%;

      color: #e8556f;
      font-size: 0.938vw;
      font-weight: bold;
      border: #e8556f 0.104vw solid;
    }
    .ac {
      color: #ffffff;
      background-color: #e8556f;
    }
    span {
      font-size: 0.729vw;
      margin-top: 0.521vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/protocol/view/ProtocolDetailPage.vue